export default "__VITE_ASSET__31f0b8f4__"